/* eslint-disable */
// ####################################+################################################
// ################# THIS IS GENERATED FILE DO NOT TOUCH!!!!!!!!!!!!####################
// ####################################-################################################
import type * as Types from '../packlets/generated'

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
import {
  UserBaseFragmentFragmentDoc,
  DiscordUserBaseFragmentFragmentDoc,
  SessionBaseFragmentFragmentDoc,
  DiscordSessionBaseFragmentFragmentDoc,
} from './users.generated'
import { DiscordInterestBaseFragmentFragmentDoc } from './discord.generated'
export type CreateDiscordAuthorizationLinkMutationVariables = Types.Exact<{
  redirectUrl: Types.Scalars['String']
}>

export type CreateDiscordAuthorizationLinkMutation = {
  __typename?: 'Mutation'
  createDiscordAuthorizationLink: string
}

export type ExchangeDiscordCodeResponseFragment_LoginResponse_Fragment = {
  __typename?: 'LoginResponse'
  user: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
  session: {
    __typename?: 'Session'
    token: string
    expiresAt: string
    isActive: boolean
    subscriptionProductType: Types.UserSubscriptionProductType
  }
}

export type ExchangeDiscordCodeResponseFragment_MultipleAccountsResponse_Fragment =
  {
    __typename?: 'MultipleAccountsResponse'
    accounts: Array<{
      __typename?: 'User'
      id: string
      isOnboardingCompleted: boolean
      isTutorialCompleted: boolean
      createdAt: string
      updatedAt: string
      name?: string | null | undefined
      email?: string | null | undefined
      isAdmin: boolean
      discordServer?: Types.SecuredServer | null | undefined
      discordCountryCode?: Types.CountryCode | null | undefined
      countryCode?: Types.CountryCode | null | undefined
      currency?: Types.CurrencyCode | null | undefined
      type: Types.UserType
      totalRafflesEntered: number
      subscriptionType?: Types.UserSubscriptionType | null | undefined
      userSubscriptionProductType: Types.UserSubscriptionProductType
      discordUser?:
        | {
            __typename?: 'DiscordUser'
            id: string
            username: string
            email: string
            avatar: string
            isVerified: boolean
            createdAt: string
            updatedAt: string
            scope: string
            accessTokenExpiresAt?: string | null | undefined
          }
        | null
        | undefined
      discordInterests: Array<{
        __typename?: 'DiscordInterest'
        type: Types.DiscordInterestType
        name: string
        description?: string | null | undefined
      }>
      metadata: {
        __typename?: 'UserMetadata'
        experienceLevel?: Types.ExperienceLevel | null | undefined
        userBehaviour?: Types.UserBehaviour | null | undefined
        dateOfBirth?: string | null | undefined
      }
    }>
    session: {
      __typename?: 'DiscordSession'
      token: string
      expiresAt: string
      isActive: boolean
    }
  }

export type ExchangeDiscordCodeResponseFragmentFragment =
  | ExchangeDiscordCodeResponseFragment_LoginResponse_Fragment
  | ExchangeDiscordCodeResponseFragment_MultipleAccountsResponse_Fragment

export type ExchangeDiscordCodeMutationVariables = Types.Exact<{
  input: Types.ExchangeDiscordCodeInput
}>

export type ExchangeDiscordCodeMutation = {
  __typename?: 'Mutation'
  exchangeDiscordCode:
    | {
        __typename?: 'LoginResponse'
        user: {
          __typename?: 'User'
          id: string
          isOnboardingCompleted: boolean
          isTutorialCompleted: boolean
          createdAt: string
          updatedAt: string
          name?: string | null | undefined
          email?: string | null | undefined
          isAdmin: boolean
          discordServer?: Types.SecuredServer | null | undefined
          discordCountryCode?: Types.CountryCode | null | undefined
          countryCode?: Types.CountryCode | null | undefined
          currency?: Types.CurrencyCode | null | undefined
          type: Types.UserType
          totalRafflesEntered: number
          subscriptionType?: Types.UserSubscriptionType | null | undefined
          userSubscriptionProductType: Types.UserSubscriptionProductType
          discordUser?:
            | {
                __typename?: 'DiscordUser'
                id: string
                username: string
                email: string
                avatar: string
                isVerified: boolean
                createdAt: string
                updatedAt: string
                scope: string
                accessTokenExpiresAt?: string | null | undefined
              }
            | null
            | undefined
          discordInterests: Array<{
            __typename?: 'DiscordInterest'
            type: Types.DiscordInterestType
            name: string
            description?: string | null | undefined
          }>
          metadata: {
            __typename?: 'UserMetadata'
            experienceLevel?: Types.ExperienceLevel | null | undefined
            userBehaviour?: Types.UserBehaviour | null | undefined
            dateOfBirth?: string | null | undefined
          }
        }
        session: {
          __typename?: 'Session'
          token: string
          expiresAt: string
          isActive: boolean
          subscriptionProductType: Types.UserSubscriptionProductType
        }
      }
    | {
        __typename?: 'MultipleAccountsResponse'
        accounts: Array<{
          __typename?: 'User'
          id: string
          isOnboardingCompleted: boolean
          isTutorialCompleted: boolean
          createdAt: string
          updatedAt: string
          name?: string | null | undefined
          email?: string | null | undefined
          isAdmin: boolean
          discordServer?: Types.SecuredServer | null | undefined
          discordCountryCode?: Types.CountryCode | null | undefined
          countryCode?: Types.CountryCode | null | undefined
          currency?: Types.CurrencyCode | null | undefined
          type: Types.UserType
          totalRafflesEntered: number
          subscriptionType?: Types.UserSubscriptionType | null | undefined
          userSubscriptionProductType: Types.UserSubscriptionProductType
          discordUser?:
            | {
                __typename?: 'DiscordUser'
                id: string
                username: string
                email: string
                avatar: string
                isVerified: boolean
                createdAt: string
                updatedAt: string
                scope: string
                accessTokenExpiresAt?: string | null | undefined
              }
            | null
            | undefined
          discordInterests: Array<{
            __typename?: 'DiscordInterest'
            type: Types.DiscordInterestType
            name: string
            description?: string | null | undefined
          }>
          metadata: {
            __typename?: 'UserMetadata'
            experienceLevel?: Types.ExperienceLevel | null | undefined
            userBehaviour?: Types.UserBehaviour | null | undefined
            dateOfBirth?: string | null | undefined
          }
        }>
        session: {
          __typename?: 'DiscordSession'
          token: string
          expiresAt: string
          isActive: boolean
        }
      }
}

export type ExchangeDiscordSessionMutationVariables = Types.Exact<{
  accountId: Types.Scalars['String']
}>

export type ExchangeDiscordSessionMutation = {
  __typename?: 'Mutation'
  exchangeDiscordSession: {
    __typename?: 'LoginResponse'
    user: {
      __typename?: 'User'
      id: string
      isOnboardingCompleted: boolean
      isTutorialCompleted: boolean
      createdAt: string
      updatedAt: string
      name?: string | null | undefined
      email?: string | null | undefined
      isAdmin: boolean
      discordServer?: Types.SecuredServer | null | undefined
      discordCountryCode?: Types.CountryCode | null | undefined
      countryCode?: Types.CountryCode | null | undefined
      currency?: Types.CurrencyCode | null | undefined
      type: Types.UserType
      totalRafflesEntered: number
      subscriptionType?: Types.UserSubscriptionType | null | undefined
      userSubscriptionProductType: Types.UserSubscriptionProductType
      discordUser?:
        | {
            __typename?: 'DiscordUser'
            id: string
            username: string
            email: string
            avatar: string
            isVerified: boolean
            createdAt: string
            updatedAt: string
            scope: string
            accessTokenExpiresAt?: string | null | undefined
          }
        | null
        | undefined
      discordInterests: Array<{
        __typename?: 'DiscordInterest'
        type: Types.DiscordInterestType
        name: string
        description?: string | null | undefined
      }>
      metadata: {
        __typename?: 'UserMetadata'
        experienceLevel?: Types.ExperienceLevel | null | undefined
        userBehaviour?: Types.UserBehaviour | null | undefined
        dateOfBirth?: string | null | undefined
      }
    }
    session: {
      __typename?: 'Session'
      token: string
      expiresAt: string
      isActive: boolean
      subscriptionProductType: Types.UserSubscriptionProductType
    }
  }
}

export type GetActiveUserAccountsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GetActiveUserAccountsQuery = {
  __typename?: 'Query'
  activeUserAccounts: Array<{
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }>
}

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never }>

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean }

export const ExchangeDiscordCodeResponseFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExchangeDiscordCodeResponseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExchangeDiscordCodeResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LoginResponse' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserBaseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'session' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SessionBaseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MultipleAccountsResponse' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserBaseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'session' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DiscordSessionBaseFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExchangeDiscordCodeResponseFragmentFragment,
  unknown
>
export const CreateDiscordAuthorizationLinkDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDiscordAuthorizationLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'redirectUrl' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDiscordAuthorizationLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'redirectUrl' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'redirectUrl' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDiscordAuthorizationLinkMutation,
  CreateDiscordAuthorizationLinkMutationVariables
>
export const ExchangeDiscordCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExchangeDiscordCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ExchangeDiscordCodeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exchangeDiscordCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'ExchangeDiscordCodeResponseFragment',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...ExchangeDiscordCodeResponseFragmentFragmentDoc.definitions,
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
    ...SessionBaseFragmentFragmentDoc.definitions,
    ...DiscordSessionBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ExchangeDiscordCodeMutation,
  ExchangeDiscordCodeMutationVariables
>
export const ExchangeDiscordSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExchangeDiscordSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exchangeDiscordSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserBaseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'session' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SessionBaseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
    ...SessionBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ExchangeDiscordSessionMutation,
  ExchangeDiscordSessionMutationVariables
>
export const GetActiveUserAccountsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActiveUserAccounts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeUserAccounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetActiveUserAccountsQuery,
  GetActiveUserAccountsQueryVariables
>
export const LogoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Logout' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'logout' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>
